import { z } from "zod";

const proposalPart = z.object({
  type: z.enum(["tool-prepareCreateProject", "tool-prepareDuplicateProject"]),
  state: z.literal("output-available"),
  output: z.object({ kind: z.literal("project-proposal"), proposalId: z.string().min(1) }),
});

/**
 * Project proposal ids produced by the prepare tools in a UI message. The web panel renders a
 * review card per id, and saved history stores them so the card survives a reload.
 */
export function getProjectProposalIds(parts: readonly unknown[]) {
  return [
    ...new Set(
      parts.flatMap((part) => {
        const parsed = proposalPart.safeParse(part);
        return parsed.success ? [parsed.data.output.proposalId] : [];
      }),
    ),
  ];
}
